	import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { ConfigService } from '../ConfigService';

@Injectable()
export class CommendationService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService,
		private configData: ConfigService
	){
		this.url = urlService.getURL('Commendation');
	}
	
	loadAll(id: System.Guid, start: Date, finish: Date) : Observable<ePM.Logic.Commendation[]> {
		var urlStr = this.url + '?personID=' + (id || '') + "&start=";
		if (start) {
			urlStr += this.configData.CombineDateAndTime(start, null).toISOString();
		} else {
			urlStr += '1/1/1900';
		}
		urlStr += "&finish=";
		if (finish) {
			urlStr += this.configData.CombineDateAndTime(finish, null).toISOString();
		} else {
			urlStr += '1/1/2500';
		}
		return this.myBaseService.loadAll(urlStr);
	}
	loadAllToApprove(): Observable<ePM.Logic.Commendation[]> {
		return this.myBaseService.loadAll(this.url + '/ToApprove');
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.Commendation> {
		return this.myBaseService.save(tempItem, this.url);
	}
	approveItem(id: System.Guid, resolution: string): Observable<ePM.Logic.Commendation> {
        return this.myBaseService.post(resolution, this.url + '/Approve/' + id);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.Commendation> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<ePM.Logic.Commendation>{
		return this.myBaseService.get(id, this.url);
	}
}
